/* Kameo winkelzoeker: kaart + lijst + slim zoeken + locatie.
   Data komt live uit Stockist (zelfde bron als de oude widget), met een
   meegeleverd JSON-bestand als terugval. */
(function () {
  'use strict';
  if (window.__kameoWK) return;
  window.__kameoWK = true;
  // Kaartijking: gemeten inkt-bbox van de NL-illustratie t.o.v. de geografische hoeken
  var KAART = { left: .0850, right: .8926, top: .1283, bottom: .7988,
                latMax: 53.55, latMin: 50.75, lonMin: 3.36, lonMax: 7.23 };

  function naarXY(lat, lon) {
    return {
      x: (KAART.left + (lon - KAART.lonMin) / (KAART.lonMax - KAART.lonMin) * (KAART.right - KAART.left)) * 100,
      y: (KAART.top + (KAART.latMax - lat) / (KAART.latMax - KAART.latMin) * (KAART.bottom - KAART.top)) * 100
    };
  }
  function afstand(a, b, c, d) {
    var R = 6371, dLat = (c - a) * Math.PI / 180, dLon = (d - b) * Math.PI / 180;
    var q = Math.pow(Math.sin(dLat / 2), 2) +
            Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.pow(Math.sin(dLon / 2), 2);
    return Math.round(2 * R * Math.asin(Math.sqrt(q)));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function normaliseer(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')  // accenten weg
      .replace(/[^a-z0-9]/g, '');
  }

  function initLocator(root) {
    if (root.dataset.kcInit) return;
    root.dataset.kcInit = '1';

    var lijst = root.querySelector('[data-kc-lijst]'),
        kaart = root.querySelector('[data-kc-kaart]'),
        zoek = root.querySelector('[data-kc-zoek]'),
        wis = root.querySelector('[data-kc-wis]'),
        telAantal = root.querySelector('[data-kc-telaantal]'),
        geen = root.querySelector('[data-kc-geen]'),
        legenda = root.querySelector('[data-kc-legenda]'),
        dichtbij = root.querySelector('[data-kc-dichtbij]'),
        hint = root.querySelector('[data-kc-hint]'),
        detail = root.querySelector('[data-kc-detail]'),
        winkels = [], actief = null, tip = null;

    function bouwPins() {
      winkels.forEach(function (w, i) {
        var p = naarXY(w.lat, w.lon);
        var pin = document.createElement('span');
        pin.className = 'pin';
        pin.dataset.i = i;
        pin.style.left = p.x + '%';
        pin.style.top = p.y + '%';
        pin.title = w.n;
        pin.addEventListener('click', function () { kies(i, true); });
        pin.addEventListener('mouseenter', function () { toon(i); });
        pin.addEventListener('mouseleave', function () { if (actief !== i) verberg(); });
        kaart.appendChild(pin);
      });
      tip = document.createElement('div');
      tip.className = 'pin-tip';
      kaart.appendChild(tip);
    }
    function toon(i) {
      var w = winkels[i], p = naarXY(w.lat, w.lon);
      tip.innerHTML = '<b>' + esc(w.n) + '</b>' + esc(w.a) + ', ' + esc(w.s);
      tip.style.left = p.x + '%';
      tip.style.top = p.y + '%';
      tip.classList.add('aan');
    }
    function verberg() { if (tip) tip.classList.remove('aan'); }
    function toonDetail(i) {
      if (!detail) return;
      var w = winkels[i];
      var route = 'https://www.google.com/maps/dir/?api=1&destination=' +
                  encodeURIComponent('Swiss Sense ' + w.a + ', ' + w.p + ' ' + w.s);
      detail.innerHTML =
        '<button class="sluit" aria-label="Sluiten">&times;</button>' +
        '<h4>' + esc(w.n) + (w.km != null ? '<span class="afstand">' + w.km + ' km</span>' : '') + '</h4>' +
        '<p>' + esc(w.a) + ', ' + esc(w.p) + ' ' + esc(w.s) + '</p>' +
        '<div class="acties">' +
          '<a class="route" href="' + route + '" target="_blank" rel="noopener"><svg viewBox="0 0 24 24"><path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>Route</a>' +
          (w.t ? '<a class="bel" href="tel:' + esc(w.t).replace(/[^0-9+]/g, '') + '"><svg viewBox="0 0 24 24"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z"/></svg>' + esc(w.t) + '</a>' : '') +
        '</div>';
      detail.hidden = false;
      detail.querySelector('.sluit').addEventListener('click', function () {
        detail.hidden = true;
        actief = null;
        root.querySelectorAll('.pin').forEach(function (p) { p.classList.remove('actief'); });
        verberg();
      });
    }
    function kies(i, vanafKaart) {
      actief = i;
      root.querySelectorAll('.pin').forEach(function (p) { p.classList.toggle('actief', +p.dataset.i === i); });
      root.querySelectorAll('.winkel').forEach(function (el) { el.classList.toggle('actief', +el.dataset.i === i); });
      toon(i);
      toonDetail(i);
      if (vanafKaart && !document.body.classList.contains('kc-toon-kaart')) {
        var el = root.querySelector('.winkel[data-i="' + i + '"]');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
    function render(set, hintTekst) {
      lijst.innerHTML = '';
      telAantal.textContent = set.length;
      if (legenda) legenda.textContent = set.length === winkels.length
        ? winkels.length + ' Swiss Sense winkels'
        : set.length + ' van ' + winkels.length + ' winkels';
      geen.classList.toggle('aan', set.length === 0);
      if (detail) detail.hidden = true;
      if (hint) { hint.innerHTML = hintTekst || ''; hint.style.display = hintTekst ? 'block' : 'none'; }
      var zichtbaar = {};
      set.forEach(function (w) { zichtbaar[winkels.indexOf(w)] = 1; });
      root.querySelectorAll('.pin').forEach(function (p) { p.classList.toggle('gedimd', !zichtbaar[+p.dataset.i]); });
      set.forEach(function (w) {
        var i = winkels.indexOf(w);
        var el = document.createElement('div');
        el.className = 'winkel';
        el.dataset.i = i;
        var route = 'https://www.google.com/maps/dir/?api=1&destination=' +
                    encodeURIComponent('Swiss Sense ' + w.a + ', ' + w.p + ' ' + w.s);
        el.innerHTML =
          '<h3>' + esc(w.n) + (w.km != null ? '<span class="afstand">' + w.km + ' km</span>' : '') + '</h3>' +
          '<p>' + esc(w.a) + ', ' + esc(w.p) + ' ' + esc(w.s) + '</p>' +
          '<div class="winkel-acties">' +
            '<a href="' + route + '" target="_blank" rel="noopener"><svg viewBox="0 0 24 24"><path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>Route</a>' +
            (w.t ? '<a href="tel:' + esc(w.t).replace(/[^0-9+]/g, '') + '"><svg viewBox="0 0 24 24"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z"/></svg>' + esc(w.t) + '</a>' : '') +
          '</div>';
        el.addEventListener('click', function () { kies(i, false); });
        lijst.appendChild(el);
      });
    }

    /* Slim zoeken: vind een middelpunt bij de zoekterm en sorteer alles op afstand.
       Werkt op plaatsnaam, winkelnaam en postcode; bij een postcode zonder eigen winkel
       schatten we het middelpunt via de numeriek dichtstbijzijnde postcodes, want
       Nederlandse postcodes lopen geografisch op. */
    function middelpunt(q) {
      var qn = normaliseer(q);
      if (!qn) return null;
      var exact = winkels.filter(function (w) {
        return normaliseer(w.s).indexOf(qn) === 0 || normaliseer(w.n).indexOf(qn) === 0;
      });
      if (!exact.length) exact = winkels.filter(function (w) {
        return normaliseer(w.s).indexOf(qn) > -1 || normaliseer(w.n).indexOf(qn) > -1;
      });
      if (exact.length) return { lat: exact[0].lat, lon: exact[0].lon, naam: exact[0].s, exact: true };

      var cijfers = (q.match(/\d{4}/) || [])[0];
      if (cijfers) {
        var pcExact = winkels.filter(function (w) { return (w.p || '').indexOf(cijfers) === 0; });
        if (pcExact.length) return { lat: pcExact[0].lat, lon: pcExact[0].lon, naam: pcExact[0].s, exact: true };
        var doel = parseInt(cijfers, 10);
        var buren = winkels.slice().map(function (w) {
          return { w: w, d: Math.abs(parseInt((w.p || '9999').slice(0, 4), 10) - doel) };
        }).sort(function (a, b) { return a.d - b.d; }).slice(0, 3);
        var lat = 0, lon = 0;
        buren.forEach(function (b) { lat += b.w.lat; lon += b.w.lon; });
        return { lat: lat / buren.length, lon: lon / buren.length, naam: buren[0].w.s, exact: false };
      }
      return null;
    }
    /* PDOK Locatieserver: de officiele Nederlandse geocoder (open, geen sleutel).
       Hiermee werkt elke plaats, wijk of postcode, ook waar geen winkel zit. */
    function geocodeNL(q) {
      var url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fl=weergavenaam,centroide_ll&fq=' +
                encodeURIComponent('type:(woonplaats OR postcode OR weg OR adres)') +
                '&q=' + encodeURIComponent(q);
      return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        var doc = d && d.response && d.response.docs && d.response.docs[0];
        if (!doc || !doc.centroide_ll) return null;
        var m = doc.centroide_ll.match(/POINT\(([\d.\-]+) ([\d.\-]+)\)/);
        if (!m) return null;
        return { lon: parseFloat(m[1]), lat: parseFloat(m[2]), naam: doc.weergavenaam, exact: true };
      }).catch(function () { return null; });
    }

    function toonResultaat(mid, q, scrollNaarLijst) {
      if (!mid) {
        winkels.forEach(function (w) { w.km = null; });
        render([], '');
        return;
      }
      winkels.forEach(function (w) { w.km = afstand(mid.lat, mid.lon, w.lat, w.lon); });
      var set = winkels.slice().sort(function (a, b) { return a.km - b.km; });
      render(set, 'Dichtstbijzijnde winkels bij <b>' + esc(q) + '</b>' + (mid.exact ? '' : ' (bij benadering)'));
      if (set.length) kies(winkels.indexOf(set[0]), false);
      if (scrollNaarLijst) naarLocator();
    }

    var zoekBeurt = 0;
    function filter(scrollNaarLijst) {
      var q = (zoek.value || '').trim();
      wis.classList.toggle('aan', q.length > 0);
      if (!q) { winkels.forEach(function (w) { w.km = null; }); render(winkels); return; }
      var beurt = ++zoekBeurt;
      // direct de eigen match tonen zodat typen soepel voelt
      toonResultaat(middelpunt(q), q, false);
      if (q.length < 3) { if (scrollNaarLijst) naarLocator(); return; }
      geocodeNL(q).then(function (mid) {
        if (beurt !== zoekBeurt) return;          // nieuwere zoekopdracht wint
        if (mid) toonResultaat(mid, q, scrollNaarLijst);
        else if (scrollNaarLijst) naarLocator();
      });
    }
    zoek.addEventListener('input', function () { filter(false); });
    zoek.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); filter(true); } });
    wis.addEventListener('click', function () { zoek.value = ''; filter(false); zoek.focus(); });

    function naarLocator() {
      var doel = root.closest('section') || root;
      var y = doel.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    // hero-zoekveld voedt de locator en scrollt bij verzenden
    var heroZoek = document.querySelector('[data-kc-herozoek]');
    if (heroZoek) heroZoek.addEventListener('input', function (e) { zoek.value = e.target.value; filter(false); });
    var heroForm = document.querySelector('[data-kc-heroform]');
    if (heroForm) heroForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (heroZoek) zoek.value = heroZoek.value;
      filter(true);
    });

    function gebruikLocatie(knop, standaardTekst) {
      if (!navigator.geolocation) return;
      var origineel = knop.innerHTML;
      knop.textContent = 'Locatie zoeken...';
      navigator.geolocation.getCurrentPosition(function (pos) {
        winkels.forEach(function (w) { w.km = afstand(pos.coords.latitude, pos.coords.longitude, w.lat, w.lon); });
        var set = winkels.slice().sort(function (a, b) { return a.km - b.km; });
        zoek.value = ''; wis.classList.remove('aan');
        if (heroZoek) heroZoek.value = '';
        render(set, 'Winkels bij jou in de buurt, dichtstbijzijnde eerst');
        kies(winkels.indexOf(set[0]), false);
        knop.innerHTML = origineel;
        naarLocator();
      }, function () {
        knop.innerHTML = origineel;
        if (hint) { hint.textContent = 'We konden je locatie niet ophalen. Zoek anders op plaats of postcode.'; hint.style.display = 'block'; }
      });
    }
    if (dichtbij) dichtbij.addEventListener('click', function () { gebruikLocatie(dichtbij); });
    var heroLocatie = document.querySelector('[data-kc-herolocatie]');
    if (heroLocatie) heroLocatie.addEventListener('click', function () { gebruikLocatie(heroLocatie); });

    function start(data) {
      winkels = data;
      bouwPins();
      render(winkels);
    }
    function uitStockist(rijen) {
      return rijen.map(function (x) {
        return { n: (x.name || '').replace('Swiss Sense ', ''), s: x.city || '',
                 a: x.address_line_1 || '', p: x.postal_code || '', t: x.phone || '',
                 lat: parseFloat(x.latitude), lon: parseFloat(x.longitude) };
      }).filter(function (w) { return !isNaN(w.lat) && !isNaN(w.lon); })
        .sort(function (a, b) { return a.s.localeCompare(b.s, 'nl'); });
    }
    var tag = root.dataset.bron, fallback = root.dataset.fallback;
    var bron = tag ? fetch('https://stockist.co/api/v1/' + tag + '/locations/all')
                       .then(function (r) { return r.json(); }).then(uitStockist)
                   : Promise.reject();
    bron.then(function (d) { if (!d.length) throw 0; start(d); })
        .catch(function () { fetch(fallback).then(function (r) { return r.json(); }).then(start).catch(function(){}); });
  }

  function initSchakel(scope) {
    scope.querySelectorAll('[data-kc-schakel]').forEach(function (rij) {
      if (rij.dataset.kcInit) return;
      rij.dataset.kcInit = '1';
      rij.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          rij.querySelectorAll('button').forEach(function (k) { k.classList.remove('aan'); });
          b.classList.add('aan');
          document.body.classList.toggle('kc-toon-kaart', b.dataset.weergave === 'kaart');
        });
      });
    });
  }
  function init(scope) {
    scope.querySelectorAll('[data-kc-locator]').forEach(initLocator);
    initSchakel(scope);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
